import { render, staticRenderFns } from "./DobSnackbar.vue?vue&type=template&id=4f9a2104&scoped=true"
import script from "./DobSnackbar.vue?vue&type=script&lang=js"
export * from "./DobSnackbar.vue?vue&type=script&lang=js"
import style0 from "./DobSnackbar.vue?vue&type=style&index=0&id=4f9a2104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a2104",
  null
  
)

export default component.exports